import { REFRESH_WORKFLOW_FORMS } from "../../actions/action-types";
import { addProjectWorkflows, deleteProjectWorkflows } from "../../actions/projectWorkflows";
import { updateProjectWorflowList } from "../../actions/projectWorkflows";
import { setAssignmentDefaults } from "../../actions/taskSidebar";
import { mergeSmartChipsIntoFormData } from "../../components/Forms/utils/smartChipsUtils";
import { workflowQuote } from "../../components/Workflow/workflow.constants";
import { notifyIcon, quote, requestMethod } from "../../config";
import config from "../../env.config";
import store from "../../store";
import { checkApiSuccess } from "../../utils";
import { getNotification } from "../../utils/common";
import { fetch } from "./api.service";

const WORKFLOW_URL = `${config.BASE_URL.BASE_API_URL}/workflow`;
const EMAIL_URL = `${config.BASE_URL.BASE_API_URL}/email`;
const WORKFLOW_TASK = `${config.BASE_URL.BASE_API_URL}/workflowTask`;

export const addWorkflow = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addWorkflow`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      if (response.data.data.Id) {
        return response.data;
      } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
    }
  };
};

export const getWorkflow = async (data) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getWorkflowDetails`,
    params: {
      workflowId: data.workflowId,
      isWorkflow: data.isWorkflow,
    },
  };
  let response = data.workflowId && (await fetch(requestConfig, true, true));
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const editWorkflow = (data) => {
  const {
    auth: {
      user: { id },
    },
  } = store.getState();
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflow`,
      data: { userId: id, ...data },
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const addWorkflowElement = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addWorkflowElement`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data[0];
    }
  };
};

export const getWorkflowDefaults = async (data) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getWorkflowDefaults`,
    params: data,
  };
  let response = data.userId && data.projectId && (await fetch(requestConfig, true, true));
  if (checkApiSuccess(response)) {
    store.dispatch(setAssignmentDefaults(response.data.data));
    return response.data.data;
  }
};

export const addWorkflowDescription = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addWorkflowDescription`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const addWorkflowSubtasks = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addWorkflowSubtasks`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const addWorkflowChildtasks = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addWorkflowChildtasks`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const addWorkflowAttachments = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addWorkflowAttachments`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const editWorkflowAttachment = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflowAttachment`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const editWorkflowDescription = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflowDescription`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const editWorkflowElement = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflowElement`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const deleteWorkflowElement = async (payload) => {
  const requestConfig = {
      method: requestMethod.DELETE,
      url: `${WORKFLOW_URL}/deleteWorkflowElement`,
      data: payload,
    },
    response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const deleteWorkflow = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.DELETE,
        url: `${WORKFLOW_URL}/deleteWorkflow`,
        data: payload,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(deleteProjectWorkflows({ workflowId: payload.workflowId, projectId: payload.projectId }));
      getNotification(quote.WORKFLOW_DELETED, notifyIcon.SUCCESS_ICON);
      return response.data.data;
    }
  };
};

export const deleteWorkflowSubtask = async (payload) => {
  const requestConfig = {
      method: requestMethod.DELETE,
      url: `${WORKFLOW_URL}/deleteWorkflowSubtask`,
      data: payload,
    },
    response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const editWorkflowSubtask = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflowSubtask`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const addWorkflowStages = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addWorkflowStages`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const deleteWorkflowChildtask = async (payload) => {
  const requestConfig = {
      method: requestMethod.DELETE,
      url: `${WORKFLOW_URL}/deleteWorkflowChildtask`,
      data: payload,
    },
    response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const editWorkflowChildtask = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflowChildtask`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const editSorting = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${config.BASE_URL.BASE_API_URL}/common/editSorting`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const editWorkflowStages = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflowStages`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      if (data.stageId === data.incomingStage?.value) {
        updateProjectWorflowList("defaultAssignee", data.defaultAssignee, data?.projectId, data.workflowId);
      }
      return response.data.data;
    }
  };
};

export const getProjectWorkflowsDropdown = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_URL}/getProjectWorkflows`,
      params: {
        projectId: data.projectId,
        userId: data.userId,
      },
    };
    let response = await fetch(requestConfig, false, true);
    if (checkApiSuccess(response)) {
      dispatch(addProjectWorkflows({ projectId: data.projectId, workflows: response.data.data[0] }));
      return response.data.data[0];
    }
  };
};

export const getWorkflowDescription = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_URL}/getWorkflowDescription`,
      params: payload,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const getWorkflowSubtasks = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_URL}/getWorkflowSubtasks`,
      params: payload,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const getWorkflowChildTasks = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_URL}/getWorkflowChildTasks`,
      params: payload,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const getWorkflowAttachments = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${WORKFLOW_URL}/getWorkflowAttachments`,
      params: payload,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

/** updates the WorkflowEmail
 * @author {Sarthak Arora}
 */
export const editWorkflowEmail = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflowEmail`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

/** updates the edit Acknowlegement Template
 * for workflows
 * @author {Sarthak Arora}
 */
export const editAcknowledgementTemplate = async (data) => {
  let requestConfig = {
    method: requestMethod.PUT,
    url: `${WORKFLOW_URL}/editAcknowledgementTemplate`,
    data: data,
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const addWorkflowReminder = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addWorkflowReminder`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const deleteWorkflowReminder = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.DELETE,
        url: `${WORKFLOW_URL}/deleteWorkflowReminder`,
        data: payload,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const editWorkflowReminder = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflowReminder`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const addNewWorkflowReminders = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addNewWorkflowReminders`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const updateWorkflowFeatureSetting = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/updateWorkflowFeatureSetting`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const addNewWorkflowFeature = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addNewWorkflowFeature`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
  };
};

export const getEmailAiPrompt = async (payload) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${EMAIL_URL}/getEmailAiPrompt`,
    params: payload,
  };
  let response = payload && (await fetch(requestConfig, true, true));
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const addEmailAiPrompt = async (data) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${EMAIL_URL}/addEmailAiPrompt`,
    data: { promptDetails: data },
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const updateEmailAiPrompt = async (data) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${EMAIL_URL}/updateEmailAiPrompt`,
    data: data,
  };
  const response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    getNotification(quote.DEFAULT_PROMPT_EMAIL_SUMMARY_UPDATED, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

export const editWorkflowAIDescription = async (data) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${WORKFLOW_URL}/editWorkflowAIDescription`,
    data: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getWorkflowAIFeature = async (workflowId) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getWorkflowAIFeature`,
    params: { workflowId },
  };
  let response = workflowId && (await fetch(requestConfig, false, false));
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getIntegrationKeyList = async (data) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getIntegrationKeyList`,
    params: {
      companyId: data.companyId,
      page: data.page || 1,
      sortBy: data.sortBy || "createdAt",
      sortOrder: data.sortOrder || -1,
      search: data.search || "",
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const updateWorkflowIds = async (payload) => {
  const requestPayload = {
    method: requestMethod.PUT,
    url: `${WORKFLOW_URL}/updateWorkflowIds`,
    data: payload,
  };
  const response = await fetch(requestPayload, false, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getIntegrationByWorkflowId = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getIntegrationByWorkflowId`,
    params: {
      companyId: data.companyId,
      workflowId: data.workflowId,
      page: data.page || 1,
      search: data.search || "",
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data;
  }
};

export const getEmailAttachments = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${EMAIL_URL}/getEmailAttachments`,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const addUploadedEmailAttachments = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${EMAIL_URL}/addUploadedEmailAttachments`,
      data: payload,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const deleteEmailAttachment = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.DELETE,
        url: `${EMAIL_URL}/deleteEmailAttachment`,
        data: payload,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const addWorkflowForm = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addWorkflowForm`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      if (response.data.data._id) {
        getNotification(quote.ON_SAVE, notifyIcon.SUCCESS_ICON);
        return response.data;
      } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
    }
  };
};

export const checkWorkflowNameAvailability = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${WORKFLOW_URL}/checkWorkflowNameAvailability`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const checkFormNameAvailability = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${WORKFLOW_URL}/checkFormNameAvailability`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getWorkflowForms = async (data) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getWorkflowForms`,
    params: data,
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getWorkflowFormById = async (data) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getWorkflowFormById`,
    params: data,
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    const formData = response.data.data;

    // Merge smartChips into form data if smartChips exist (new structure)
    // Otherwise use content as-is (backward compatibility with old forms)
    if (formData?.content?.smartChips && Object.keys(formData.content.smartChips).length > 0) {
      formData.content = mergeSmartChipsIntoFormData(formData.content, formData.content.smartChips);
    }
    return formData;
  }
};

export const editWorkflowForm = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_URL}/editWorkflowForm`,
      data: data,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      getNotification(quote.ON_UPDATE, notifyIcon.SUCCESS_ICON);

      return response.data.data;
    }
  };
};

export const deleteWorkflowForm = async (payload) => {
  const requestConfig = {
      method: requestMethod.DELETE,
      url: `${WORKFLOW_URL}/deleteWorkflowForm`,
      data: payload,
    },
    response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const submitForm = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_TASK}/submitForm`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      if (response.data.data._id) {
        getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
        const currentPath = window.location.pathname;
        if (currentPath.includes("/workflow/")) {
          dispatch({ type: REFRESH_WORKFLOW_FORMS });
        }

        return response.data;
      } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
    }
  };
};

export const editFormSubmission = (data) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.PUT,
      url: `${WORKFLOW_TASK}/updateFormSubmission`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

/**
 * Get submitted form data for a task
 * @param {Object} data - Contains formId and taskId
 * @returns {Promise} Submitted form data with filled values
 * @author [Sarthak]
 */
export const getFormSubmission = async (data) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_TASK}/getFormSubmission`,
    params: {
      submittedFormId: data?.submittedFormId,
    },
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    const formData = response.data.data;
    // Merge smartChips into form data if smartChips exist (new structure)
    // Otherwise use content as-is (backward compatibility with old forms)
    if (formData?.content?.smartChips && Object.keys(formData.content.smartChips).length > 0) {
      formData.content = mergeSmartChipsIntoFormData(formData.content, formData.content.smartChips);
    }
    return formData;
  }
};

export const getActiveMemberVariables = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/getActiveMemberVariables`,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const updateFormFilterAsLastFilter = (data) => {
  return async () => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_TASK}/updateFormFilterAsLastFilter`,
      data: data,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const getUserAccessibleWorkflows = async (data) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${WORKFLOW_URL}/GetUserAccessibleWorkflows`,
    params: data,
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const generateFormDescription = async (data) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${WORKFLOW_URL}/generateFormDescription`,
    data: { id: data.id },
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const generateFormAiDescription = async (data) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${WORKFLOW_URL}/generateFormAiDescription`,
    data: { id: data.id },
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getUserChips = async (data) => {
  const url = `${config.BASE_URL.BASE_API_URL}/common/getAdminVariableItemsByCompany`;
  const requestConfig = {
    method: requestMethod.GET,
    url: url,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const addOrUpdateWorkflowExpression = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${WORKFLOW_URL}/addOrUpdateWorkflowExpression`,
      data: payload,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const getWorkflowExpressionByVariableId = async (data) => {
  const url = `${WORKFLOW_URL}/getWorkflowExpressionByVariableId`;
  const requestConfig = {
    method: requestMethod.GET,
    url: url,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const addWorkflowCustomPrivacy = async (data) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${WORKFLOW_URL}/addWorkflowCustomPrivacy`,
    data: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};
